module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    staticClass: "noprint",
    attrs: {
      "app": "",
      "clipped": "",
      "persistent": "",
      "enable-resize-watcher": "",
      "fixed": ""
    },
    model: {
      value: (_vm.showDrawer),
      callback: function($$v) {
        _vm.showDrawer = $$v
      },
      expression: "showDrawer"
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": "",
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-content', [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding-top": "8px"
    },
    attrs: {
      "src": 'static/logo.png'
    }
  })]), _vm._v(" "), (_vm.isMobile) ? _c('v-list-item-action', [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "text": ""
          }
        }, on), [_c('v-icon', {
          attrs: {
            "x-large": ""
          }
        }, [_vm._v("account_circle")])], 1)]
      }
    }], null, false, 2945925129)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    attrs: {
      "to": {
        name: 'userMe'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Profile")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-item-title', [_vm._v("Logout")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.localSearchClear
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), _c('v-list-group', {
    attrs: {
      "prepend-icon": "local_offer"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Categories")])], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.localSearchClear()
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("All")])], 1)], 1), _vm._v(" "), _vm._l((_vm.getCategories), function(category) {
    return _c('v-list-item', {
      key: category.id,
      on: {
        "click": function($event) {
          return _vm.localSearchCategory(category)
        }
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(category.name))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-list-group', {
    attrs: {
      "prepend-icon": "label"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Tags")])], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _vm._l((_vm.tags), function(tag) {
    return _c('v-list-item', {
      key: tag,
      on: {
        "click": function($event) {
          return _vm.localSearchTag(tag)
        }
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(tag))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "to": {
        name: 'qrCode'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("reorder")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("QR Code Generator")])], 1)], 1), _vm._v(" "), _vm._l((_vm.menu), function(item, i) {
    return [(item.items) ? [_c('v-list-group', {
      key: i
    }, [_c('template', {
      slot: "activator"
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(item.action))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1), _vm._v(" "), _vm._l((item.items), function(subItem) {
      return _c('v-list-item', {
        key: subItem.title,
        attrs: {
          "to": {
            name: subItem.route
          }
        }
      }, [_c('v-list-item-action'), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(subItem.title))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(subItem.action))])], 1)], 1)
    })], 2)] : [_c('v-list-item', {
      key: i,
      attrs: {
        "to": {
          name: item.route
        }
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(item.action))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)]]
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "rgba(0,0,0,0.07)"
    }
  }, [_c('v-list-item-action', [_c('v-icon')], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("v" + _vm._s(_vm.version))])], 1)], 1), _vm._v(" "), _c('v-divider')], 2)], 1), _vm._v(" "), _c('v-app-bar', {
    staticClass: "noprint",
    attrs: {
      "app": "",
      "fixed": "",
      "clipped-left": "",
      "clipped-right": ""
    }
  }, [_c('v-app-bar-nav-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDrawer = !_vm.showDrawer
      }
    }
  }, [_c('v-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('search-bar', {
    staticStyle: {
      "margin": "15px"
    },
    attrs: {
      "categories": _vm.getCategories,
      "disabled": _vm.disableSearch
    }
  }), _vm._v(" "), (!_vm.isMobile) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "text": ""
          }
        }, on), [_c('v-icon', {
          attrs: {
            "x-large": ""
          }
        }, [_vm._v("account_circle")])], 1)]
      }
    }], null, false, 2945925129)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    attrs: {
      "to": {
        name: 'userMe'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Profile")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-item-title', [_vm._v("Logout")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-main', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39a3b056","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 403
// module chunks = 1